var _linearGradient, _radialGradient, _linearGradient2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndiaThunderball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e89623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9dd62"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 21.245,
    cy: 24.448,
    r: 8.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1ca4d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a66a7"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    y1: 3.317,
    x2: 0.5,
    y2: -2.332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e89623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9dd62"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.343 14.404h25.852c.41 0 .745.808.745 1.782v25.639a.748 1.789 0 0 1-.745 1.782H14.343c-.407 0-.742-.808-.742-1.782V16.186c0-.981.335-1.782.742-1.782z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 .506C38.451.506 49.344 11.489 49.344 25S38.421 49.494 25 49.494C11.519 49.494.656 38.511.656 25 .626 11.489 11.489.506 25 .506z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.402 15.04 18.591 26.113l6.981 2.528-5.055 9.479 12.367-12.157-5.236-3.129z",
    fill: "url(#c)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaThunderball);
export default __webpack_public_path__ + "static/media/india_thunderball.082a609418df5bb47012a7992e738223.svg";
export { ForwardRef as ReactComponent };